export default __webpack_public_path__ + "static/Airgap-Zero-Trust Enterprise-a6ad14ad92ce121f71f70b282235acf2.pdf";